export default __webpack_public_path__ + "static/media/FP_FR_GM.faaebd7f.png";